// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"271":"a6a0cd3763d26f87f9a8","314":"9c5d0aa601536342aaa0","553":"916b6d5a1efa675d6ca9","628":"10b635f4483f42d72ece","967":"4ee2ed5e3b7ec48c60ff"}[chunkId] + ".js";
};